//# data-scroll-to="selector"

//# initScrollTo
initScrollTo()
function initScrollTo() {
  const links = document.querySelectorAll('[data-scroll-to]')
  if (links.length > 0) {
    document.addEventListener('click', click)
  }
}

//# click
function click(e) {
  if (e.target.closest('[data-scroll-to]')) {
    const selector = e.target.closest('[data-scroll-to]').dataset.scrollTo
    const headerHeight = document.querySelector('header').offsetHeight
    const documentScroll = document.documentElement.scrollTop
    const top = document.querySelector(selector).getBoundingClientRect().top + documentScroll - headerHeight - 40

    window.scrollTo({ top: top, behavior: 'smooth' })

    e.preventDefault()
  }
}
